var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.eventWinnerComponent,{tag:"component",attrs:{"event-data":_vm.eventWinnerData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }